import React, { useState, useEffect } from 'react'
import {Grid, Container, Stack, AppBar, IconButton, Alert} from '@mui/material'
import {Logout} from '@mui/icons-material'
import WbButton from '../../components/common/WbButton'
import ConversationCard from './ConversationCard'
import { useNavigate  } from 'react-router-dom';
import paths from '../../routes/paths'
import unifiedLogout from '../../utils/unifiedLogout'
import CircularProgress from '@mui/material/CircularProgress';
import { safeSpaceApi } from '../../services/api/safespace/safeSpaceApi';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function Conversations() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openConversations, setOpenConversations] = useState([]);
  const [closedConversations, setClosedConversations] = useState([]);

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        setLoading(true);
        const pupilData = JSON.parse(localStorage.getItem('pupil') || '{}');
        //debugger;
        const payload = {
          studentId: pupilData.studentId,
          groupId: pupilData.groupId,
          schoolIds: [pupilData.schoolId],
          status: "ALL",
          isMAT: pupilData.groupId ? true : false
        };

        // const payload = {
        //   studentId: 148788,
        //   groupId: 201,
        //   schoolIds: [1595],
        //   status: "ALL",
        //   isMAT: true
        // };

        const response = await safeSpaceApi.GetSafeSpaceConversationsbyStudentId(payload);
        
        if (response) {
          // Split conversations based on isConversationClosed flag
          const open = response.filter(conv => !conv.isConversationClosed);
          const closed = response.filter(conv => conv.isConversationClosed);
          
          setOpenConversations(open);
          setClosedConversations(closed);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch conversations:', error);
        setLoading(false);
      }
    };

    fetchConversations();
  }, []);

  return (
    <>
      <AppBar className="header">
        <Container maxWidth="xxl">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className="logo">
              <span>Welbee</span>
            </div>
            <div>
              <nav>
                <WbButton
                  onClick={() => {
                    unifiedLogout()
                  }}
                  CustomButtonText="Logout"
                />                  
              </nav>
            </div>
          </Stack>
        </Container>
      </AppBar>
      <div className="main-container">
        <Container maxWidth="lg"> 
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '500px' }}>
              <CircularProgress />
              <div style={{ marginTop: '16px', color: '#555', fontSize: '16px' }}>Loading conversations List....</div>
            </div>
          ) : (
            <Grid container spacing={2} mt={1} mb={4}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 2, md: 0 }} justifyContent="space-between" alignItems="center">
                  <h1>My Safe Space</h1>
                  <WbButton 
                    className="start-new-conversation"
                    CustomButtonText={'Start New Conversation'}
                    onClick={e => navigate(paths.selectStaff)}
                  />
                </Stack>
              </Grid>             


              {/* Open Conversations */}
              {openConversations.length > 0 && (
                <>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <h1 className="conversation-heading">Open Conversations</h1>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="conversation-list">
                      {openConversations.map(conversation => (
                        <div key={conversation.conversationId} style={{ marginBottom: 12 }}>
                          <ConversationCard conversation={conversation} />
                        </div>
                      ))}
                    </div>
                  </Grid>
                </>
              )}


              {/* Closed Conversations */}
              {closedConversations.length > 0 && (
                <>
                  <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
                    <h1 className="conversation-heading">Closed Conversations</h1>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="conversation-list">
                      {closedConversations.map(conversation => (
                        <div key={conversation.conversationId} style={{ marginBottom: 12 }}>
                          <ConversationCard conversation={conversation} />
                        </div>
                      ))}
                    </div>
                  </Grid>
                </>
              )}

            </Grid>          
          )}

          {openConversations.length === 0 && closedConversations.length === 0 && !loading && (

            <Alert severity="error" icon={<InfoOutlinedIcon fontSize="inherit" />}>No Conversation Found</Alert>
            // <div style={{ textAlign: 'center', marginTop: '50px' }}>
            //   <h2>No Conversations Found</h2>
            //   <p>Start a new conversation to get help and support.</p>
            //   <WbButton 
            //     CustomButtonText={'Start New Conversation'}
            //     onClick={e => navigate(paths.selectStaff)}
            //   />
            // </div>
          )}
        </Container>
      </div>
    </>    
  )
}

